import { DependencyList, useEffect, useRef } from 'react'

import { CommandBarItem } from '../types'
import { useCommandBarRegistration } from '../context'

export const useRegisterCommandBarCommands = (
  key: string,
  createCommands: () => CommandBarItem[],
  dependencies: DependencyList
) => {
  const { registerCommands } = useCommandBarRegistration()
  const createCommandsRef = useRef(createCommands)

  createCommandsRef.current = createCommands

  useEffect(() => {
    const commands = createCommands().map((command, index) => ({
      ...command,
      run: () => createCommandsRef.current()[index]?.run(),
    }))

    return registerCommands(key, commands)
    // The caller owns when command metadata should be re-registered. Command
    // callbacks stay fresh through createCommandsRef, so callback identity
    // changes do not need to churn provider state.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, registerCommands, ...dependencies])
}
